import axios from '../../definitions/axios';

export const checkAnalytics = ({ action, extraReferrer }: { action: string | undefined; extraReferrer?: string }) => {
  return axios.post('/analytic/visitor/',  {referrer: extraReferrer }  );
};

export const Subscribe = ({ email }: { email:  string }) => {
  return axios.post('/user/subscriber/', { email },  { headers: { referrer: document?.referrer } }  );
};


